const e=(e,t=!0,o)=>{const r=document.querySelector(`script[src="${e}"]`);r&&t&&r.remove();const c=r||document.createElement("script");return c.type="text/javascript",c.src=e,o&&(c.onload=o),document.body.insertBefore(c,document.body.firstChild),c};export{e as insertScript};
//# sourceMappingURL=insertScript.js.map
